import { Permission } from 'openapi/api/model';
import { createContext, useState } from 'react';

export type AuthState={
    user: string | null;
    token: string | null;
    permission: Permission | undefined;
}

export type SessionContext = {
    sessionData: null | AuthState;
    setSessionData: (data: AuthState) => void;
  };
  

export const AuthContext = createContext({
    sessionData: null as null | AuthState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSessionData: (_:AuthState)=>{},
} as SessionContext);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AuthStateProvider = ({children}: any) => {
    const [authData, setAuthData] = useState<null | AuthState>(null);
    const setSessionData = (incomingData:AuthState) => {
        console.log({incomingData})
        setAuthData(incomingData);
    }

    const value = {
        sessionData:authData,
        setSessionData,
    }

    return(
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthStateProvider;